<template>
  <div :loading="dataLoading"
       class="home"
       :style="{ height: screenHeight + 'px', width: screenWidth + 'px',background:`linear-gradient( 180deg,${topicObj.bgcolorTopValue},${topicObj.bgcolorBottomValue})`}">
    <div class="top-bg">
      <img :src="topicObj.topMidPic"
           alt />
    </div>
    <div class="title">
      <img :src="topicObj.topTitlePic"
           alt />
    </div>
    <p class="desc">{{topicObj.remark}}</p>
    <wx-open-launch-weapp
      id="launch-btn"
      class="launch-btn"
      v-if="isWx"
      :username="jumpWeappOptions.username"
      :path="jumpWeappOptions.path"
      :style="{backgroundImage: `url(${topicObj.buttonPic})`}"
    >
      <script type="text/wxtag-template">
        <style>.btn { width: 100px; height: 50px; opacity: 0 }</style>
        <button class="btn"></button>
      </script>
    </wx-open-launch-weapp>
    <div class="btn-bg" v-else>
      <img @click="handleShowMask()"
           :src="topicObj.buttonPic"
           alt />
    </div>
    <div class="bottom-bg">
      <img :src="topicObj.bottomBgPic"
           alt />
    </div>
    <div v-if="showMask"
         class="mask">
      <img class="close"
           @click="handleClose"
           src="../assets/img/icon_close@1x.png"
           alt />
      <div class="code">
        <div class="code-t">
          <img :src="Qrcode"
               alt />
        </div>
        <p>长按小程序码，进入投稿页面</p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src 'backgroud':`lineargradient(180deg,${topBg}, ${bottomBg})`
import { getTopicAdvPage, getQrCode } from "../server/api";
import initWxShare from "../../src/utlis/initWxShare";
import getSystemInfo from "../../src/utlis/getSystemIno";
export default {
  name: "home",
  data() {
    return {
      topicObj: {
        // bgcolorTopValue: "",
        // bgcolorBottomValue: "",
        // bottomBgPic: "",
        // buttonPic: "",
        // remark: "",
        // shareIcon: "",
        // title: "",
        // topMidPic: "",
        // topTitlePic: "",
        // topicId: ""
      },
      dataLoading: false,
      screenHeight: 0,
      screenWidth: 0,
      showMask: false,
      Qrcode: "",
      id: "",
      isNfPlus: false,
      jumpWeappOptions: {
        username: 'gh_6298954024f9',
        // 'pages/reportData/reportData/reportData.html?scene=wxTopicId%3D2'
        targetPath: 'pages/reportData/reportData/reportData.html',
        params: {
          wxTopicId: ''
        },
        path: 'pages/reportData/reportData/reportData.html'
      }
    };
  },
  created() {
    window.nfplusJsbridge.setShareInfo({
      shareDesc: `“南方+”创造更多价值！`,
      shareIcon: "https://static.nfapp.southcn.com/common/assets/images/nf_logo_share300x300.png",
      shareTitle: " ",
      shareUrl: window.location.href
    });
    window.console.log(process.env.VUE_APP_RUN_ENV, 'process.env.VUE_APP_RUN_ENV')
    if (window.location.search.indexOf("&") !== -1) {
      this.id = window.location.search
        .split("?")[1]
        .split("=")[1]
        .split("&")[0];
    } else {
      this.id = window.location.search.split("?")[1].split("=")[1];
    }
    this.isAPP();
    this.getSetData();
  },
  methods: {
    // 微信方法分享   https://teststatic.nfapp.southcn.com/hd/reportPropagate/index.html?id=408?&
    sendFrends() {
      const origin = window.location.origin;
      const pathname = window.location.pathname;
      const shareInfo = {
        title: this.topicObj.title,
        desc: this.topicObj.remark,
        link: `${origin}${pathname}?id=${this.id}?&from=singlemessage`,
        imgUrl: this.topicObj.shareIcon
      };
      initWxShare(shareInfo);
    },
    // 获取小程序二维码
    async getQ() {
      let params = {
        topicId: this.id
      };
      let res = await getQrCode(params);
      this.Qrcode = res.data.data;
    },
    //获取配置信息
    async getSetData() {
      this.dataLoading = true;
      let params = {
        topicId: this.id
      };
      let res = await getTopicAdvPage(params);
      this.topicObj = res.data.data;
      window.console.log(this.topicObj);
      let title = document.getElementsByTagName("title");
      title[0].innerHTML = this.topicObj.title;
      this.sendFrends();
      this.initJumpWeappOptions(this.topicObj)
      window.nfplusJsbridge.setTitleBarAttribute({
        title: this.topicObj.title
      });
      window.nfplusJsbridge.setShareInfo({
        shareDesc: this.topicObj.remark,
        shareIcon: this.topicObj.shareIcon,
        shareTitle: this.topicObj.title,
        shareUrl: window.location.href
      });
      this.dataLoading = false;
    },
    //判断打开环境 shareIcon
    isWX() {
      return (
        window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !==
        -1
      );
    },
    async isAPP() {
      let res = await getSystemInfo();
      this.isNfPlus = res.isNfPlus;
    },
    handleShowMask() {
      if (this.isWX()) {
        this.getQ();
        this.showMask = true;
      } else {
        if (this.isNfPlus) {
          window.location.href = `nfp:///{"type": "tips", "id": ${this.id}}`;
        } else {
          window.OpenApp({
            id: this.id,
            shareType: "reportEntry"
          });
        }
      }
    },
    handleClose() {
      this.showMask = false;
    },
    qsJumpWeappParams(params) {
      let qsParams = Object.keys(params).map(key => {
        return `${key}=${params[key]}`
      }).join('&')
      qsParams = encodeURIComponent(qsParams)
      return qsParams ? `?scene=${qsParams}` : ''
    },
    initJumpWeappEvent() {
      const btn = document.getElementById('launch-btn')
      btn.addEventListener('launch', function (e) {
        window.console.log('success')
      })
    },
    initJumpWeappOptions(topicConfig) {
      this.jumpWeappOptions.params.wxTopicId = topicConfig.topicId
      this.jumpWeappOptions.path = `${this.jumpWeappOptions.targetPath}${this.qsJumpWeappParams(this.jumpWeappOptions.params)}`
      this.isWx && this.initJumpWeappEvent()
    }
  },
  computed: {
    isWx() {
      return window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
    }
  },
  mounted() {
    this.screenHeight = document.documentElement.clientHeight;
    this.screenWidth = document.documentElement.clientWidth;
  }
};
</script>
<style lang="scss">
#app {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border: none;
  .home {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    background-size: 100% 100%;
    user-select: none;
    img {
      -webkit-touch-callout: none;
      user-select: none;
    }
    .mask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.7);
      z-index: 12;
      .close {
        position: absolute;
        top: 0.3rem;
        right: 0.3rem;
        width: 0.68rem;
        height: 0.68rem;
      }
      .code {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: absolute;
        left: 50%;
        top: 40%;
        transform: translate(-50%, -50%);
        .code-t {
          width: 4.44rem;
          height: 4.44rem;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 20px;
          background: #ffffff;
          img {
            width: 3.3rem;
            height: 3.3rem;
          }
        }
      }
      p {
        margin-top: 0.4rem;
        width: 4.2rem;
        height: 0.64rem;
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #ffffff;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 32px;
        padding: 0.14rem 0.41rem;
      }
    }
    .top-bg {
      width: 100%;
      height: 6.14rem;
      position: absolute;
      top: 0;
      img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        margin-left: 0%;
        border: 0;
      }
    }
    .title {
      width: 5.9rem;
      height: 1.33rem;
      position: absolute;
      left: 3.6rem;
      top: 1.8rem;
      transform: translate(-50%, -50%);
      img {
        width: 100%;
        //vertical-align: middle;
      }
    }
    .desc {
      //margin-top: 0.6rem;
      width: 6.3rem;
      height: 2rem;
      position: absolute;
      left: 50%;
      top: 3.9rem;
      transform: translate(-50%, -50%);
      word-wrap: break-word;
      word-break: normal;
      font-family: PingFang-SC-Bold;
      font-size: 0.3rem;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 0.5rem;
      box-sizing: border-box;
      text-align: left;
    }
    .btn-bg {
      position: absolute;
      left: 50%;
      top: 6.25rem;
      transform: translate(-50%, -50%);
      height: 1.4rem;
      width: 5.4rem;
      z-index: 11;
      img {
        width: 100%;
        //vertical-align: middle;
      }
    }
    .bottom-bg {
      width: 100%;
      position: absolute;
      bottom: 0;
      height: calc(100% - 6.14rem);
      img {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        margin-left: 0%;
        border: 0;
        //vertical-align: middle;
      }
    }
  }
}
.launch-btn {
  position: absolute;
  left: 50%;
  top: 6.25rem;
  transform: translate(-50%, -50%);
  height: 1.4rem;
  width: 5.4rem;
  z-index: 11;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  img {
    width: 100%;
  }
}
</style>
